var map = {
	"./top-1.png": "T4kf",
	"./top-2.png": "veLD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "w23w";


//////////////////
// WEBPACK FOOTER
// ./static/ugc/creation/filter ^\.\/top\-.*\.png$
// module id = w23w
// module chunks = 1